import CareersHero from "../components/Careers/CareersHero";
import TeamsAndMission from "../components/Careers/TeamsAndMission";
import HowWeWork from "../components/Careers/HowWeWork";

const CareersPage: React.FC = () => {
  return (
    <>
      <CareersHero />
      <TeamsAndMission />
      <HowWeWork />
    </>
  );
};

export default CareersPage;
